var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2925 6.61665L7.40079 16.5083C6.51746 17.4 3.87578 17.8083 3.27578 17.2166C2.67578 16.6249 3.10079 13.9833 3.98413 13.0917L13.8758 3.20001C14.3326 2.76502 14.9412 2.52582 15.5719 2.5335C16.2026 2.5412 16.8053 2.79516 17.2513 3.24116C17.6973 3.68715 17.9512 4.28985 17.959 4.92054C17.9666 5.55123 17.7275 6.15992 17.2925 6.61665Z",
    stroke: "#4E465E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.73c679d38d31a669d51f7d4a8e332571.svg";
export { ForwardRef as ReactComponent };